export const HOME_URL: string = "/";